import an from "./locales.en";
import fr from "./locales.fr";
export default {
  fr: fr,
  an: an,
};
